import { useMemo as r, useRef as t } from "react";
import e from "../../node_modules/lodash-es/isEqual.js";
const o = (o2, n) => r(o2, ((o3) => {
  const n2 = t(o3), c = t(0);
  return e(o3, n2.current) || (n2.current = o3, c.current += 1), r(() => n2.current, [c.current]);
})(n));
export {
  o as useDeepCompareMemo
};
//# sourceMappingURL=useDeepCompareMemo.js.map
